/* tslint:disable */
/* eslint-disable */
/**
 * Web App core API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface LaundryReferenceSimple
 */
export interface LaundryReferenceSimple {
    /**
     * UUID of the Laundry
     * @type {string}
     * @memberof LaundryReferenceSimple
     */
    id: string;
    /**
     * Name of the Laundry
     * @type {string}
     * @memberof LaundryReferenceSimple
     */
    readonly name: string | null;
}

/**
 * Check if a given object implements the LaundryReferenceSimple interface.
 */
export function instanceOfLaundryReferenceSimple(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "name" in value;

    return isInstance;
}

export function LaundryReferenceSimpleFromJSON(json: any): LaundryReferenceSimple {
    return LaundryReferenceSimpleFromJSONTyped(json, false);
}

export function LaundryReferenceSimpleFromJSONTyped(json: any, ignoreDiscriminator: boolean): LaundryReferenceSimple {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
    };
}

export function LaundryReferenceSimpleToJSON(value?: LaundryReferenceSimple | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
    };
}

